// Booking slot helpers
// Schedule: Mon-Thu 10:00-14:00 + 16:00-19:00, Fri 10:00-14:00. 45-min slots.

export type Slot = { start: string; end: string };

function addMinutes(time: string, minutes: number): string {
  const [h, m] = time.split(":").map(Number);
  const total = h * 60 + m + minutes;
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
}

function slotsInWindow(start: string, end: string, durationMin = 45): Slot[] {
  const result: Slot[] = [];
  let cursor = start;
  while (true) {
    const next = addMinutes(cursor, durationMin);
    if (next > end) break;
    result.push({ start: cursor, end: next });
    cursor = next;
  }
  return result;
}

/** Returns all configured slots for a given JS Date. Sundays/Saturdays = []. */
export function slotsForDate(date: Date): Slot[] {
  const day = date.getDay(); // 0=Sun, 1=Mon ... 5=Fri, 6=Sat
  if (day === 0 || day === 6) return [];
  if (day === 5) return slotsInWindow("10:00", "14:00");
  // Mon - Thu
  return [...slotsInWindow("10:00", "14:00"), ...slotsInWindow("16:00", "19:00")];
}

export function formatDateISO(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
